module.exports = __webpack_public_path__ + "img/approve-list14.bacb33d3.png";